import React from "react";
import { motion } from "framer-motion";
import { PRINCIPLES } from "../data/content";

export default function Manifesto() {
    return (
        <section
            id="manifesto"
            data-testid="manifesto-section"
            className="relative py-24 sm:py-36 border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <div className="overline mb-5">The Manifesto</div>
                        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#f4f4f0]">
                            Twelve laws.
                            <br />
                            <span className="italic text-[#990000]">
                                Zero negotiation.
                            </span>
                        </h2>
                        <p className="mt-8 text-neutral-400 max-w-md">
                            These are not opinions. They are the operating
                            principles every man inside the Code lives by. Read
                            them slowly. They will offend you before they free
                            you.
                        </p>
                    </div>

                    <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/5">
                        {PRINCIPLES.map((p, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-50px" }}
                                transition={{
                                    duration: 0.7,
                                    delay: (i % 6) * 0.05,
                                    ease: [0.16, 1, 0.3, 1],
                                }}
                                data-testid={`principle-${i}`}
                                className="bg-[#050505] p-7 hover:bg-[#0c0303] transition-colors duration-500 group"
                            >
                                <div className="font-mono-accent text-[11px] text-[#7A0000] mb-3 group-hover:text-[#990000] transition-colors">
                                    {String(i + 1).padStart(2, "0")} ·
                                </div>
                                <div className="font-serif-display text-lg sm:text-xl text-neutral-200 leading-snug">
                                    {p}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
